import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { DashboardSidebar } from '@/layouts/dashboard';
import { Link } from 'react-router-dom';
import { Filter, FilterTitle } from '@/components/custom/filter';
import { Button, ButtonBack, ButtonBackContent } from '@/components/ui/button';
import { IconWrapper } from '@/components/custom/icon';
import { AvatarWrapper } from '@/components/ui/avatar';
import { EssayPageTiaContent } from '@/components/custom/essay';
import imgTia from '@/app/components/TIA/img/tia-avatar.png';

export function EssaySendSidebar({ essayId }) {
  return (
    <DashboardSidebar
      hasBrand={false}
      viewMode="create"
    >
      <Filter>
        <ButtonBack asChild>
          <Link to={`/redacao/acompanhamento/${essayId}`}>
            <IconWrapper>
              <FiChevronLeft />
            </IconWrapper>

            <ButtonBackContent>
              <FilterTitle>Enviando a redação</FilterTitle>
            </ButtonBackContent>
          </Link>
        </ButtonBack>
      </Filter>

      <div className="relative h-20">
        <AvatarWrapper
          size="md"
          className="duration-[1500ms] absolute animate-real-bounce"
          src={imgTia}
          text="T.I.A"
        />
      </div>

      <EssayPageTiaContent
        arrowPosition="top-left"
        className="grow-0"
      >
        <h3 className="mb-3 text-base font-bold text-primary-dark">Enviando a redação</h3>
        <p className="mb-4">Escreva seu texto em nossa folha de redação (baixe e imprima no botão abaixo) ou utilize um folha pautada no tamanho A4. Depois envie a foto da redação clicando no botão ao lado “Enviar foto da redação”.</p>
        <Button
          variant="outline"
          wide
          asChild
        >
          <a
            href="/redacao.pdf"
            download="/redacao.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Baixar folha
          </a>
        </Button>
      </EssayPageTiaContent>
    </DashboardSidebar>
  );
}
